import BccRwdTargeter from 'components/Bcc/BccRwdTargeter/BccRwdTargeter';

export default BccRwdTargeter;
